module.exports = __webpack_public_path__ + "home_s3.png?9385b6f8d903b020563c441bcbdba864";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s3.png
// module id = 49
// module chunks = 0